import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import { getHotMovies, getNewMovies, getRecommendedMovies } from '@/mocks/movies';

export default function Home() {
  const hotMovies = getHotMovies();
  const newMovies = getNewMovies();
  const recommendedMovies = getRecommendedMovies();

  return (
    <>
      {/* Schema.org - WebPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '爱丫爱丫影院 - 首页',
          description: '高清电影免费在线观看，流畅播放秒开看剧，无广告不缓冲，极速观影不卡顿。海量免费电视剧每日更新。',
          url: 'https://www.aiyaaiya.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '爱丫爱丫影院',
            url: 'https://www.aiyaaiya.com',
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.aiyaaiya.com/',
              },
            ],
          },
        })}
      </script>

      {/* Schema.org - FAQPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '爱丫爱丫影院是否需要注册才能观看？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '不需要注册！爱丫爱丫影院所有高清电影和免费电视剧均可直接在线观看，无需注册登录，无需任何费用，真正做到打开即看。',
              },
            },
            {
              '@type': 'Question',
              name: '观看电影时会有广告吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '完全不会！爱丫爱丫影院承诺无广告播放体验。无论您观看任何电影、电视剧，全程都不会有任何广告打断您的观影体验。',
              },
            },
            {
              '@type': 'Question',
              name: '支持哪些设备观看？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '爱丫爱丫影院支持电脑、平板、手机等多种设备在线观看。网站采用响应式设计，自适应各种屏幕尺寸。',
              },
            },
            {
              '@type': 'Question',
              name: '视频画质如何？会不会卡顿？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们提供高清画质播放，采用先进的视频加速技术，确保流畅播放。不卡顿、不缓冲，让观影成为享受。',
              },
            },
            {
              '@type': 'Question',
              name: '网站的电影资源多久更新一次？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '爱丫爱丫影院每日更新最新的电影和电视剧资源。无论是院线大片、热播电视剧还是经典老片，都会在第一时间上线。',
              },
            },
            {
              '@type': 'Question',
              name: '遇到播放问题怎么办？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '可以通过关于我们页面的联系方式与我们取得联系。技术团队会尽快帮您解决播放问题。',
              },
            },
          ],
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero */}
          <HeroSection />

          {/* Category Navigation */}
          <CategoryNav />

          {/* Hot Movies */}
          <MovieGrid
            title="热门推荐"
            subtitle="大家都在看的精彩内容"
            icon="ri-fire-line"
            movies={hotMovies}
            accentClass="text-accent-500"
          />

          {/* New Movies */}
          <div className="bg-background-100/70">
            <MovieGrid
              title="最新上线"
              subtitle="刚刚更新的影视资源"
              icon="ri-flashlight-line"
              movies={newMovies}
              accentClass="text-primary-500"
            />
          </div>

          {/* Recommended Movies */}
          <MovieGrid
            title="高分推荐"
            subtitle="口碑炸裂的优质影片"
            icon="ri-star-line"
            movies={recommendedMovies}
            accentClass="text-accent-500"
          />

          {/* Article Section */}
          <ArticleSection />

          {/* FAQ */}
          <FAQSection />
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}